// The database key an email address is filed under.
//
// RTDB keys cannot contain a dot, so every dot is escaped. Two things make
// this worth its own module:
//
//   1. JavaScript's String.replace with a STRING pattern swaps only the first
//      match. The security rules use the rules-language replace(), which swaps
//      every match. Escaping only the first leaves a literal dot in the key,
//      which RTDB rejects outright — so `first.last@team.com` did not merely
//      look under the wrong key, it built an illegal path and the lookup threw.
//      Any admin with two dots in their email silently lost the Admin
//      Management menu.
//   2. The same key is computed in functions/middlewares.js and
//      functions/index.js. If they ever disagree, an admin is admin in one half
//      of the product and not the other.
//
// Keep in step with cleanEmailKey in functions/middlewares.js.

export function emailKey(email) {
    return String(email || '').split('.').join('%2E');
}
